import * as React from 'react';
import * as autoBind from 'react-autobind';
import {EmptyState} from '@techsmith/tsc-cloud-style-guide';
import UsersModel from '../../types/UsersModel';
import Strings from '../../globals/Strings';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import Themeable from '../../types/Themeable';
import NonOwnerReviewer from '../NonOwnerReviewer/NonOwnerReviewer';
import OwnerReviewer from '../OwnerReviewer/OwnerReviewer';
import {ModalStates} from '../../globals/Constants';

export default class ReviewersList extends React.Component<ReviewersListProps, ReviewersListState> {
   readonly state: ReviewersListState = {isSaving: false};

   constructor(props: ReviewersListProps) {
      super(props);
      autoBind(this);
   }

   orderReviewersByEmail(reviewers: SimpleReviewerModel[]): SimpleReviewerModel[] {
      return reviewers.sort((reviewer1: SimpleReviewerModel, reviewer2: SimpleReviewerModel) => {
         return reviewer1.Email < reviewer2.Email ? -1 : 1;
      });
   }

   render(): React.ReactElement<any> {
      const {reviewers, themeName, isOwner, users, removeReviewer, cancelRemoveReviewer, notifyReviewer, modalState} = this.props;
      const orderedReviewers = this.orderReviewersByEmail(reviewers);

      return (
         <React.Fragment>
            {orderedReviewers.length === 0 && <div className="reviewer-table-empty"><EmptyState title={Strings.labels.manageReviewersList.emptyState} themeName={themeName}/></div>}
            {orderedReviewers.length > 0 && <div className="reviewer-table">
               {orderedReviewers.map((reviewer, index) => isOwner ?
                  <OwnerReviewer user={users[reviewer.Id]}
                                 removeReviewer={removeReviewer}
                                 cancelRemoveReviewer={cancelRemoveReviewer}
                                 notifyReviewer={notifyReviewer}
                                 reviewer={reviewer}
                                 isSaving={this.state.isSaving}
                                 themeName={themeName}
                                 key={`reviewers-list-${index}`}
                                 modalState={modalState}/> :
                  <NonOwnerReviewer user={users[reviewer.Id]}
                                    reviewer={reviewer}
                                    key={`reviewers-list-${index}`}/>)}
            </div>}
         </React.Fragment>
      );
   }
}

export interface ReviewersListProps extends Themeable {
   users: UsersModel;
   isOwner: boolean;
   reviewers: SimpleReviewerModel[];
   modalState: ModalStates;
   cancelRemoveReviewer(reviewer: SimpleReviewerModel): void;
   removeReviewer(reviewer: SimpleReviewerModel): void;
   notifyReviewer(reviewer: SimpleReviewerModel, wantToNotify: boolean): void;
}

export interface ReviewersListState {
   isSaving: boolean;
}
